module.exports = __webpack_public_path__ + "img/600.7331eda7.svg";